'use client'
import { createContext, useReducer } from 'react'

const DtiContext = createContext()

const DTIReducer = (state, action) => {
  switch (action.type) {
    case 'SET_DATA_DTI_FORM':
      return {
        ...state,
        dataDti: action.payload.dataDti,
      }
    default:
      throw new Error(`Unhandled action type: ${action.type}`)
  }
}

const DTIProvider = ({ children, initialDataDti }) => {
  const [state, dispatch] = useReducer(DTIReducer, {
    dataDti: initialDataDti,
  })
  return (
    <DtiContext.Provider
      value={{
        state,
        dispatch,
      }}
    >
      {children}
    </DtiContext.Provider>
  )
}

export { DTIProvider, DtiContext }
